import { Input } from "../ui";

/* eslint-disable no-unused-vars */
export const NumberField = ({ formField, currentPosition, ...props }) => <Input { ...props } type="number" />;